export interface Product {
  id: string;
  name: string;
  category: string;
  categoryName: string;
  price: number;
  originalPrice: number;
  image: string;
  description: string;
  tags: string[];
  rating: number;
  sales: number;
  isNew: boolean;
  isHot: boolean;
}

export const products: Product[] = [
  {
    id: 'p001',
    name: '资生堂红妍肌活精华露 75ml',
    category: 'beauty',
    categoryName: '美妆护肤',
    price: 680,
    originalPrice: 890,
    image: 'https://readdy.ai/api/search-image?query=Premium%20Japanese%20skincare%20serum%20bottle%20elegant%20red%20gradient%20glass%20design%20on%20minimal%20cream%20background%2C%20soft%20lighting%2C%20clean%20product%20photography%2C%20luxury%20cosmetic%20presentation&width=600&height=600&seq=prod-p001&orientation=squarish',
    description: '日本资生堂明星产品，激活肌肤免疫力，提升肌肤光泽与弹性，适合所有肤质使用。',
    tags: ['精华', '护肤', '资生堂'],
    rating: 4.9,
    sales: 2380,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p002',
    name: 'SK-II 神仙水护肤精华液 230ml',
    category: 'beauty',
    categoryName: '美妆护肤',
    price: 1280,
    originalPrice: 1590,
    image: 'https://readdy.ai/api/search-image?query=SK-II%20facial%20treatment%20essence%20iconic%20glass%20bottle%20on%20minimal%20cream%20surface%2C%20elegant%20lighting%2C%20premium%20skincare%20product%20photography%2C%20clean%20composition&width=600&height=600&seq=prod-p002&orientation=squarish',
    description: '含有超过90%天然活肤酵母精华Pitera，改善肌肤五大维度，让肌肤晶莹剔透。',
    tags: ['精华水', '护肤', 'SK-II'],
    rating: 4.8,
    sales: 1850,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p003',
    name: 'CPB肌肤之钥光缎粉底液 SPF25',
    category: 'beauty',
    categoryName: '美妆护肤',
    price: 750,
    originalPrice: 920,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20luxury%20foundation%20bottle%20elegant%20dark%20design%20with%20gold%20accents%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting%2C%20premium%20cosmetic&width=600&height=600&seq=prod-p003&orientation=squarish',
    description: '蕴含光感粉末技术，打造自然透亮妆感，轻薄服帖持久不脱妆。',
    tags: ['粉底', '彩妆', 'CPB'],
    rating: 4.7,
    sales: 920,
    isNew: true,
    isHot: false,
  },
  {
    id: 'p004',
    name: '黛珂AQ珍萃精颜绮迹面霜 30g',
    category: 'beauty',
    categoryName: '美妆护肤',
    price: 1680,
    originalPrice: 2100,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20luxury%20face%20cream%20jar%20elegant%20white%20and%20silver%20design%20on%20minimal%20cream%20surface%2C%20premium%20skincare%20photography%2C%20soft%20lighting%2C%20clean%20aesthetic&width=600&height=600&seq=prod-p004&orientation=squarish',
    description: '黛珂顶级系列，融合多种珍稀成分，深层修护滋养，令肌肤焕发年轻光彩。',
    tags: ['面霜', '护肤', '黛珂'],
    rating: 4.9,
    sales: 450,
    isNew: true,
    isHot: true,
  },
  {
    id: 'p005',
    name: '无印良品超声波香薰机',
    category: 'home',
    categoryName: '家居日用',
    price: 380,
    originalPrice: 490,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20MUJI%20style%20ultrasonic%20aroma%20diffuser%20minimal%20white%20design%20on%20wooden%20table%2C%20soft%20mist%2C%20warm%20lighting%2C%20zen%20atmosphere%2C%20clean%20product%20photography&width=600&height=600&seq=prod-p005&orientation=squarish',
    description: '日式极简设计，超声波雾化技术，静音运行，营造舒适放松的家居氛围。',
    tags: ['香薰', '家居', '无印良品'],
    rating: 4.6,
    sales: 1680,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p006',
    name: '象印不锈钢保温杯 480ml',
    category: 'home',
    categoryName: '家居日用',
    price: 258,
    originalPrice: 328,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Zojirushi%20stainless%20steel%20thermos%20bottle%20sleek%20design%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20lighting%2C%20premium%20home%20goods&width=600&height=600&seq=prod-p006&orientation=squarish',
    description: '日本象印经典保温杯，真空隔热技术，保温保冷效果卓越，轻便耐用。',
    tags: ['保温杯', '家居', '象印'],
    rating: 4.8,
    sales: 3200,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p007',
    name: '北海道白色恋人巧克力夹心饼干 24枚',
    category: 'snacks',
    categoryName: '零食特产',
    price: 168,
    originalPrice: 208,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Shiroi%20Koibito%20chocolate%20sandwich%20cookies%20in%20elegant%20gift%20box%20on%20cream%20background%2C%20minimal%20food%20photography%2C%20soft%20lighting%2C%20premium%20snack%20presentation&width=600&height=600&seq=prod-p007&orientation=squarish',
    description: '北海道经典伴手礼，酥脆猫舌饼干夹心白巧克力，奶香浓郁入口即化。',
    tags: ['饼干', '零食', '北海道'],
    rating: 4.9,
    sales: 5600,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p008',
    name: '日本Royce生巧克力 原味 20粒',
    category: 'snacks',
    categoryName: '零食特产',
    price: 138,
    originalPrice: 168,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Royce%20nama%20chocolate%20box%20elegantly%20presented%20with%20cocoa%20powder%2C%20minimal%20cream%20background%2C%20premium%20food%20photography%2C%20soft%20lighting%2C%20luxurious%20chocolate&width=600&height=600&seq=prod-p008&orientation=squarish',
    description: '北海道Royce生巧克力，采用北海道鲜奶油制作，口感丝滑醇厚入口即化。',
    tags: ['巧克力', '零食', '北海道'],
    rating: 4.8,
    sales: 4200,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p009',
    name: 'FANCL芳珂综合维生素 30日分',
    category: 'health',
    categoryName: '健康保健',
    price: 198,
    originalPrice: 258,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20FANCL%20vitamin%20supplement%20packets%20elegantly%20arranged%20on%20minimal%20cream%20surface%2C%20clean%20health%20product%20photography%2C%20soft%20lighting%2C%20premium%20wellness&width=600&height=600&seq=prod-p009&orientation=squarish',
    description: '日本FANCL综合维生素，无添加配方，均衡补充日常所需维生素与矿物质。',
    tags: ['维生素', '保健', 'FANCL'],
    rating: 4.7,
    sales: 1890,
    isNew: false,
    isHot: false,
  },
  {
    id: 'p010',
    name: '小林制药退热贴 婴儿用 12枚',
    category: 'baby',
    categoryName: '母婴用品',
    price: 58,
    originalPrice: 78,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20baby%20cooling%20fever%20relief%20gel%20patches%20in%20cute%20packaging%20on%20soft%20cream%20background%2C%20gentle%20lighting%2C%20minimal%20product%20photography&width=600&height=600&seq=prod-p010&orientation=squarish',
    description: '日本小林制药退热贴，物理降温安全无刺激，适合婴儿娇嫩肌肤使用。',
    tags: ['退热贴', '母婴', '小林制药'],
    rating: 4.8,
    sales: 3500,
    isNew: false,
    isHot: true,
  },
  {
    id: 'p011',
    name: '日本宇治抹茶粉 100g 茶道级',
    category: 'snacks',
    categoryName: '零食特产',
    price: 228,
    originalPrice: 298,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20premium%20Uji%20matcha%20green%20tea%20powder%20in%20elegant%20tin%20container%20with%20bamboo%20whisk%2C%20minimal%20cream%20background%2C%20zen%20aesthetic%2C%20soft%20lighting&width=600&height=600&seq=prod-p011&orientation=squarish',
    description: '京都宇治产茶道级抹茶，色泽翠绿香气浓郁，适合制作抹茶拿铁及烘焙。',
    tags: ['抹茶', '茶饮', '宇治'],
    rating: 4.9,
    sales: 2100,
    isNew: true,
    isHot: true,
  },
  {
    id: 'p012',
    name: '狮王酵素美白牙膏 130g',
    category: 'home',
    categoryName: '家居日用',
    price: 45,
    originalPrice: 59,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Lion%20enzyme%20whitening%20toothpaste%20tube%20on%20minimal%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20lighting%2C%20dental%20care%20product&width=600&height=600&seq=prod-p012&orientation=squarish',
    description: '日本狮王酵素牙膏，含天然酵素成分，有效去除牙渍美白牙齿。',
    tags: ['牙膏', '日化', '狮王'],
    rating: 4.5,
    sales: 4800,
    isNew: false,
    isHot: false,
  },
];

export const getProductsByCategory = (categorySlug: string): Product[] => {
  return products.filter((p) => p.category === categorySlug);
};

export const getHotProducts = (limit: number = 8): Product[] => {
  return products.filter((p) => p.isHot).slice(0, limit);
};

export const getNewProducts = (limit: number = 8): Product[] => {
  return products.filter((p) => p.isNew).slice(0, limit);
};

export const getProductById = (id: string): Product | undefined => {
  return products.find((p) => p.id === id);
};